module.exports = fox._r("images/slideshow_start.png", __webpack_public_path__ + "images/slideshow_start.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/slideshow_start.png
// module id = 1116
// module chunks = 4